import { projectPositionSummary } from "../kernel/projectors.js";
import {
  commitCellUpsert,
  loadPositionForCommand,
} from "../kernel/board-engine.js";
import type { ExecutionContext } from "../runtime/context.js";
import type {
  CellListRequest,
  CellUpsertRequest,
} from "../cli/protocol.js";

export async function handleCellUpsert(
  context: ExecutionContext,
  request: CellUpsertRequest,
) {
  const result = await commitCellUpsert(context, request.s, {
    cellId: request.c,
    effect: request.e,
    from: request.f,
    fromPositionRef: request.p,
    to: request.t,
  });

  return {
    board: result.board,
    cell: result.cell,
    parent: projectPositionSummary(result.parent),
    position: projectPositionSummary(result.position),
  };
}

export async function handleCellList(
  context: ExecutionContext,
  request: CellListRequest,
) {
  const { position } = await loadPositionForCommand(context, request.s, request.p);
  return {
    cells: Object.values(position.stateSnapshot.cells).sort((left, right) =>
      left.id.localeCompare(right.id),
    ),
    position: projectPositionSummary(position),
  };
}
